import fb, { getDocsFromCollection } from '@/firebase'
import { createUserWithEmailAndPassword } from '@/firebaseAuth'
import store from '@/store'
import router from '@/router'
import request from '@/request'

const state = {
  user: null,
  employees: null,
  fetchedUser: null,
  canEdStudents: null
}

const getters = {
  user: state => state.user,
  isLogged: state => (state.user !== null),
  employees: state => state.employees,
  canEdStudents: state => state.canEdStudents,
  fetchedUser: state => state.fetchedUser
}

const mutations = {
  setUser: (state, user) => {
    state.user = user
  },
  setEmployees: (state, payload) => {
    state.employees = payload
  },
  fetchedUser: (state, payload) => {
    state.fetchedUser = payload
  },
  setCanEdStudents: (state, payload) => {
    state.canEdStudents = payload
  }
}

const actions = {
  setCurrentUser: ({ commit }, payload) => {
    if (payload) {
      commit('setUser', payload)
    } else {
      commit('setUser', fb.user())
    }
  },
  getUser: ({commit}, id) => {
    store.dispatch('setLoaderStatus', true)
    fb.getUserDetails(id)
      .then((fetched) => {
        const docData = fetched.data()
        const details = {...docData, ...{uid: fetched.id, ref: fetched.ref}}
        store.dispatch('setCurrentUser', details)
        store.dispatch('setLoaderStatus', false)
      })
  },
  getUserFetched: ({commit}, id) => {
    store.dispatch('setLoaderStatus', true)
    fb.getUserDetails(id)
      .then((fetched) => {
        const docData = fetched.data()
        const details = {...docData, ...{uid: fetched.id, ref: fetched.ref}}
        commit('fetchedUser', details)
        store.dispatch('setLoaderStatus', false)
      })
  },
  updateFetchedUser: ({ commit }, params) => {
    store.dispatch('setLoaderStatus', true)
    fb.updateUserDetails(params.id, params.payload)
      .then(() => {
        store.dispatch('setLoaderStatus', false)
        store.dispatch('setSuccessMessage', 'Details saved successfully')
        store.dispatch('getUserFetched', params.id)
      })
  },
  updateUserPassword: ({ commit }, params) => {
    store.dispatch('setLoaderStatus', true)
    fb.updateUserPassword(params.id, params.payload)
      .then(() => {
        store.dispatch('setLoaderStatus', false)
        store.dispatch('setSuccessMessage', 'Password updated successfully')
        store.dispatch('getUserFetched', params.id)
      })
  },
  updateUser: ({ commit }, params) => {
    store.dispatch('setLoaderStatus', true)
    fb.updateUserDetails(params.id, params.payload)
      .then(() => {
        store.dispatch('setLoaderStatus', false)
        store.dispatch('setSuccessMessage', 'Details saved successfully')
        store.dispatch('getUser', params.id)
        store.dispatch('getUserFetched', params.id)
      })
  },
  updateCanEdStudent: ({ commit }, params) => {
    store.dispatch('setLoaderStatus', true)
    fb.updateUserDetails(params.id, params.payload)
      .then(() => {
        store.dispatch('setLoaderStatus', false)
        store.dispatch('setSuccessMessage', 'Details saved successfully')
        store.dispatch('getCanEdStudents')
      })
  },
  addDocument: ({commit}, params) => {
    store.dispatch('setLoaderStatus', true)
    fb.uploadDocument(params.document)
      .then((snapshot) => {
        fb.updateUserDocuments(params.id, {
          doc: {url: snapshot.downloadURL, name: snapshot.metadata.name, status: 'Pending'},
          status: 'Document verification pending'
        }).then(() => {
          store.dispatch('setLoaderStatus', false)
          store.dispatch('setSuccessMessage', 'Document saved successfully')
          store.dispatch('getUser', params.id)
          store.dispatch('getUserFetched', params.id)
          store.dispatch('getCanEdStudents')
        })
      })
  },
  addUserDocumentfromEmployee: ({commit}, params) => {
    store.dispatch('setLoaderStatus', true)
    fb.uploadDocument(params.document)
      .then((snapshot) => {
        fb.updateUserDocuments(params.id, {
          doc: {url: snapshot.downloadURL, name: snapshot.metadata.name, status: 'Pending'},
          status: 'Document verification pending'
        }).then(() => {
          store.dispatch('setLoaderStatus', false)
          store.dispatch('setSuccessMessage', 'Document saved successfully')
          store.dispatch('getCanEdStudents')
          store.dispatch('getUserFetched', params.id)
        })
      })
  },
  deleteDocument: ({commit}, params) => {
    store.dispatch('setLoaderStatus', true)
    fb.deleteDocument(params.document)
      .then((snapshot) => {
        fb.deleteUserDocument(params.id, params.document).then(() => {
          store.dispatch('setLoaderStatus', false)
          store.dispatch('setSuccessMessage', 'Document deleted successfully')
          store.dispatch('getUser', params.id)
          store.dispatch('getCanEdStudents')
          store.dispatch('getUserFetched', params.id)
        })
      })
  },
  createUser: ({commit}, params) => {
    store.dispatch('setLoaderStatus', true)
    createUserWithEmailAndPassword(params.email, params.password)
      .then(response => {
        if (response) {
          delete params['password']
          fb.setUserBasicDetails(response.uid, params)
            .then(() => {
              store.dispatch('setLoaderStatus', false)
              store.dispatch('getUser', response.uid)
            })
        }
      })
  },
  createEmployee: ({commit}, params) => {
    store.dispatch('setLoaderStatus', true)
    createUserWithEmailAndPassword(params.email, params.password)
      .then(response => {
        if (response) {
          delete params['password']
          fb.setUserBasicDetails(response.uid, params)
            .then(() => {
              store.dispatch('setLoaderStatus', false)
              store.dispatch('getUser', response.uid)
              store.dispatch('getEmployees')
              router.push('/admin/employees')
            })
        }
      })
  },
  setUserBasicDetails: ({commit}, params) => {
    store.dispatch('setLoaderStatus', true)
    request.getNextUserID()
      .then(response => {
        response.json().then(data => {
          params.payload['seq_id'] = data.next_id

          fb.setUserBasicDetails(params.id, params.payload)
            .then(() => {
              store.dispatch('setLoaderStatus', false)
              store.dispatch('getUser', params.id)
              if (params.payload.type === 'Student') {
                router.push('/student')
              } else if (params.payload.type === 'Associate') {
                router.push('/associate/require-details')
              }
            })
            .catch((err) => {
              console.log(err)
            })
        })
      }).catch(error => {
        store.dispatch('setLoaderStatus', false)
        store.dispatch('setErrorMessage', "Some thing went wrong while updating basic details")
      })
  },
  getEmployees: ({commit}, id) => {
    store.dispatch('setLoaderStatus', true)
    fb.getUsersByType('Employee')
      .then((fetched) => {
        commit('setEmployees', getDocsFromCollection(fetched))
        store.dispatch('setLoaderStatus', false)
      })
  },
  getCanEdStudents: ({commit}) => {
    store.dispatch('setLoaderStatus', true)
    fb.getUsersByType('Student')
      .then((fetched) => {
        commit('setCanEdStudents', getDocsFromCollection(fetched))
        store.dispatch('setLoaderStatus', false)
      })
  },
  addStudentProfile: ({commit}, params) => {
    store.dispatch('setLoaderStatus', true)
    request.getNextUserID(params.personal_details.personal_email)
      .then(response => {
        response.json().then(data => {
          params['seq_id'] = data.next_id

          createUserWithEmailAndPassword(params.personal_details.personal_email, "caned123")
            .then(response => {
              if (response) {
                fb.setUserBasicDetails(response.uid, {...params, "type": "Student"})
                  .then(() => {
                    store.dispatch('setLoaderStatus', false)
                    store.dispatch('getUserFetched', response.uid)
                    store.dispatch('getCanEdStudents')
                  })
              }
            })          
        })
      }).catch(error => {
        store.dispatch('setLoaderStatus', false)
        store.dispatch('setErrorMessage', "Some thing went wrong while updating basic details")
      })
  },
  sendForgotPasswordMail: ({commit}, params) => {
    store.dispatch('setLoaderStatus', true)
    fb.sendPasswordResetEmail(params)
      .then(response => {
        store.dispatch('setLoaderStatus', false)
        store.dispatch('setSuccessMessage', 'Password reset email sent to your e-Mail')
      })
      .catch(err => {
        store.dispatch('setLoaderStatus', false)
        store.dispatch('setErrorMessage', 'No User exists on the email')
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js